var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tree',{attrs:{"data":_vm.dataInfo.dataList,"props":_vm.dataInfo.dataSetting,"highlight-current":true,"default-expand-all":false,"expand-on-click-node":false},on:{"node-click":_vm.handleNodeClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }